import {
    all, put, PutEffect, select, SelectEffect, takeLatest, AllEffect, ForkEffect,
} from "redux-saga/effects";
import {
    history, Nullable, safeSaga, SET_AXIOS_ERROR, setAxiosError, SetAxiosErrorAction,
} from "@data-force/app";
import StoreState from "../../interfaces/store/storeState";
import HistoryParams from "../../interfaces/historyParams";
import {getHistoryParams} from "../../utils/common";
import {RoutesMap} from "../../interfaces/common";
import {Routes} from "../../utils/constants";

export function getBaseUrl(): SelectEffect {
    return select((state: StoreState): string => state.serviceProperties.fluxUrl);
}

export function getActiveJobFilter(): SelectEffect {
    return select((state: StoreState): string => state.job.filter);
}

function* handleAxiosErrors({payload}: SetAxiosErrorAction): IterableIterator<PutEffect<SetAxiosErrorAction>> {
    if (payload) {
        const {UNAUTHORIZED, PAGE_NOT_FOUND}: RoutesMap = Routes;
        const historyParams: Nullable<HistoryParams> = getHistoryParams();

        switch (payload.response?.status) {
            case 403:
                history.push(`/${historyParams?.idpId}/${UNAUTHORIZED}`);
                break;
            case 404:
                history.push(`/${historyParams?.idpId}/${PAGE_NOT_FOUND}`);
                break;
            default:
                break;
        }

        yield put(setAxiosError(null));
    }
}

export function* mainSagaActionWatcher(): IterableIterator<AllEffect<ForkEffect>> {
    yield all([
        takeLatest(SET_AXIOS_ERROR, safeSaga(handleAxiosErrors)),
    ]);
}
